/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface SystemModeStatus {
  serviceName?: string;
  serviceInstance?: number;
  systemMode?: SystemModeStatus.SystemModeEnum;
  changeTimestamp?: string;
  sentTimestamp?: string;
}
export namespace SystemModeStatus {
  export const SystemModeEnum = {
    Active: 'ACTIVE',
    Maintenance: 'MAINTENANCE',
  } as const;
  export type SystemModeEnum = (typeof SystemModeEnum)[keyof typeof SystemModeEnum];
}
